<template>
  <div class="nights-room-selector-component">
    <v-menu offset-y attach=".rooms-select" :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs, value }">
        <div
          class="
            rooms-select
            flex grow-0
            justify-between
            items-center
            space-x-2
            relative
          "
          v-bind="attrs"
          v-on="on"
          @click="resetRoomsInput(value)"
        >
          <img src="/img/icons/bed.svg" />
          <span
            >{{ rooms }} {{ $tc("hotel.room", rooms) }}</span
          >
          <v-icon v-if="!value">mdi-chevron-down</v-icon>
          <v-icon v-else>mdi-chevron-up</v-icon>
        </div>
      </template>

      <div class="menu-content flex flex-col items-center">
        <p class="mb-3 font-bold">{{ucfirst( $tc("hotel.room", 2) )}}</p>
        <div class="quantity-container flex mb-6 justify-between items-center">
          <div
            class="quantity-icon"
            :class="{ disabled: roomsInput === 1 || roomsInput === minRooms }"
            @click.stop="roomsInput--"
          >
            <v-icon>mdi-minus</v-icon>
          </div>
          <span class="font-bold">{{ roomsInput }}</span>
          <div
            class="quantity-icon"
            :class="{ disabled: roomsInput === $store.state.nights.adults }"
            @click.stop="roomsInput++"
          >
            <v-icon>mdi-plus</v-icon>
          </div>
        </div>
        <p
          class="done self-end flex items-center justify-right"
          @click="done"
        >
          <span class="mr-1 font-bold">{{$t("shared.ready")}}</span>
          <v-icon>mdi-chevron-right</v-icon>
        </p>
      </div>
    </v-menu>
  </div>
</template>

<script>
import { NIGHTS_FETCH_AND_SET_HOTELS } from "../../../store/nights/action-types";
import { NIGHTS_GET_MIN_ROOMS } from "../../../store/nights/getter-types";
import { NIGHTS_SET_STATE } from "../../../store/nights/mutation-types";
import { SHOW_ERROR_SNACKBAR } from "../../../store/snackbar/mutation-types";
import { ucfirst } from '../../../utils/strings';

export default {
  data() {
    return {
      rooms: 1,
      roomsInput: 1,
      ucfirst
    };
  },

  computed: {
    minRooms() {
      return this.$store.getters[NIGHTS_GET_MIN_ROOMS];
    },
    roomsFromState() {
      return this.$store.state.nights.rooms;
    },
  },

  mounted(){
    this.rooms = this.minRooms > 0 ? this.minRooms : 1;
    this.roomsInput = this.minRooms > 0 ? this.minRooms : 1;
  },

  watch: {
    roomsFromState(rooms) {
      this.rooms = rooms;
      this.roomsInput = rooms;
    },
    uppercase(str) {
      slugify(str);
    }
  },

  methods: {
    resetRoomsInput(open) {
      if (!open) {
        this.roomsInput = this.rooms;
      }
    },
    async done() {
      if (this.roomsInput === this.roomsFromState) return;
      this.$store.commit(NIGHTS_SET_STATE, ["showOverlay", true]);
      try {
        this.$store.commit(NIGHTS_SET_STATE, ["rooms", this.roomsInput]);
        const unsuscribe = this.$store.subscribe(async (mutation, state) => {
          unsuscribe();
        });

        await store.dispatch(NIGHTS_FETCH_AND_SET_HOTELS, {
          rooms: this.roomsInput,
        });
      } catch (e) {
        store.commit(SHOW_ERROR_SNACKBAR);
      } finally {
        store.commit(NIGHTS_SET_STATE, ["showOverlay", false]);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../sass/_variables.scss";

.rooms-select {
  background-color: white;
  padding: 8px 15px 8px 12px;
  border: 1px solid black;
  border-radius: 10px;
  cursor: pointer;
  width: 210px;
  margin-right: 2px;
}
.menu-content {
  .quantity-container {
    width: 130px;
    shrink: 0;
  }
  .quantity-icon {
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    border: 1px solid black;
    display: flex;
    justify-content: center;
    align-items: center;

    &.disabled {
      border: 1px solid #ccc;
      pointer-events: none;
      i {
        color: #ccc;
      }
    }
  }
  .done {
    span,
    i {
      color: $turquoiseBlue;
    }
  }
}
.nights-room-selector-component::v-deep {
  .v-menu__content {
    top: calc(100% + 8px) !important;
    left: 0 !important;
    margin: 0 !important;
    padding: 1rem;
    background-color: white;
  }
}
</style>
